import React from "react";

function OfferCard({ img, title, des }) {
  return (
    <div className="flex flex-col items-center mt-14">
      <img src={img} className="h-14" />
      <p className="font-bold mt-5">{title}</p>
      <p className=" mt-2 text-gray-500 text-center">{des}</p>
    </div>
  );
}

export default OfferCard;
